export function commandOrControl() {
  const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
  return isMac ? 'Command' : 'Control';
}
